function deleteDecimalsWithZero(numero: number | string) {
  // Convertir el número a cadena
  var numeroComoCadena = Number(numero).toFixed(2).toString();

  // Verificar si termina con ".00"
  if (numeroComoCadena.endsWith('.00')) {
    // Eliminar los dos últimos caracteres (".00")
    return numeroComoCadena.slice(0, -3);
  } else {
    // Devolver el número sin cambios
    return numeroComoCadena;
  }
}

function oneHundredAsPercentage(numero: number | string) {
  var numeroAsNumber = Number(numero);

  // Verificar si termina con ".00"
  if (numeroAsNumber > 100) {
    // Eliminar los dos últimos caracteres (".00")
    numeroAsNumber=100;
    return numeroAsNumber;
  } else {
    // Devolver el número sin cambios
    return numeroAsNumber;
  }
}

const OnlyKeepTwoDecimals = ({ value }: { value: number }) => {
  const valueSplit = value.toString().split('.')
  const newValue = Number((valueSplit[0] ?? '0') + '.' + (valueSplit[1]?.slice(0, 2) ?? '0'))
  return newValue
}
export function roundTo(n, decimals = 2) {
  const f = 10 ** decimals;
  return Math.round((n + Number.EPSILON) * f) / f;
}
export { deleteDecimalsWithZero, OnlyKeepTwoDecimals, oneHundredAsPercentage };
